import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';

import type { TArrowIcon } from './models';

export const ArrowIcon: FC<TArrowIcon> = ({ isOpen = true, styles, ...other }) => {
    const classNames = cn(styles.arrowIcon, {
        [styles.arrowIconOpened]: isOpen,
    });

    return (
        <svg
            className={classNames}
            data-test-id="arrow"
            fill="none"
            height="30"
            viewBox="0 0 30 30"
            width="30"
            xmlns="http://www.w3.org/2000/svg"
            {...other}
        >
            <path
                d="M14.8925 17.186L20.4325 11.646L21.1395 12.354L14.8925 18.6L8.64648 12.354L9.35448 11.646L14.8925 17.186Z"
                fill="black"
            />
        </svg>
    );
};
